module.exports = __webpack_public_path__ + "img/14.ccb8a3af.png";